import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fortuneronrentinpune() {



const cardData = {
  keyword: " Fortuner On Rent in Pune ",

headingDescription: "Velocity Cab offers Fortuner on rent in Pune, providing a premium, powerful, and comfortable SUV option ideal for family outings, corporate travel, group trips, and long‑distance journeys. Our well‑maintained Toyota Fortuner vehicles deliver robust performance, excellent road presence, and spacious seating for passengers with ample luggage space. Whether you need an hourly rental, full‑day service, airport transfers, or outstation travel, Velocity Cab offers flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt service, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Fortuner rental in Pune.",

topPlaces: [
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a historic hill fortress near Pune known for its panoramic views of the Sahyadri mountains and rich Maratha heritage. Travelers renting a Fortuner in Pune can enjoy a comfortable scenic drive through winding roads to reach the fort, explore its ancient gates and bastions, and trek along trails offering breathtaking vistas. The summit is an excellent spot for photography, picnics, and tasting local Maharashtrian snacks like pithla bhakri from vendors."
  },
  {
    title: "Lavasa City",
    description: "Lavasa City is a picturesque hill‑station‑style destination near Pune known for its vibrant waterfront, lush green hills, and European‑inspired architecture. Visitors with a Fortuner rental can take a comfortable drive from Pune to Lavasa, enjoy boat rides on the lake, explore cafes and scenic promenades, and capture beautiful landscape views. The powerful SUV ensures a smooth journey through hilly terrains and winding roads."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a popular scenic destination near Pune, known for its tranquil waters, camping spots, and stunning sunset views. Travelers renting a Fortuner can drive to the lake, set up picnics or tents, and engage in outdoor activities like kayaking or bonfires. The spacious and powerful SUV ensures comfort even on rural or uneven roads leading up to the lake."
  },
  {
    title: "Mulshi Dam",
    description: "Mulshi Dam is a beautiful reservoir surrounded by lush hills and valleys, making it a favorite spot for nature lovers. Visitors with a Fortuner on rent can explore the serene surroundings, enjoy picnics, and take in sweeping views of the water and greenery. The SUV’s stability and power make driving around the dam area pleasurable for families and groups alike."
  },
  {
    title: "Rajmachi Fort",
    description: "Rajmachi Fort is an adventurous destination near Pune that combines history with rugged terrain. Travelers in a Fortuner rental can trek to the fort, explore its ancient ruins, and enjoy stunning views of the surrounding hills. The powerful SUV is perfect for navigating rougher sections of roads and reaching off‑beat spots comfortably."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a serene getaway near Pune known for paragliding activities, lakes, and peaceful countryside vibes. Travelers using a Fortuner on rent can comfortably drive through scenic routes to reach paragliding take‑off points, relax by lakes, and enjoy panoramic hill views. The SUV’s stability and power ensure a smooth journey through rural paths."
  },
  {
    title: "Tamhini Ghat",
    description: "Tamhini Ghat is a scenic mountain pass near Pune famous for its waterfalls, lush greenery, and winding roads. Visitors renting a Fortuner can enjoy a powerful and comfortable drive along the ghat’s curves, stop at cascading waterfalls, and capture picturesque landscape views. The region is especially beautiful during the monsoon season when nature is at its peak."
  },
  {
    title: "Bhaja Caves",
    description: "Bhaja Caves are ancient rock‑cut Buddhist caves near Pune featuring intricate carvings and historical significance. Travelers with a Fortuner rental can explore these heritage caves set amidst lush landscape and hilly terrain. The powerful SUV makes the journey to these off‑beat destinations easy and comfortable, ideal for history buffs and nature lovers."
  },
  {
    title: "Khandala Viewpoint",
    description: "Khandala Viewpoint offers breathtaking views of the Western Ghats and is a popular spot for nature enthusiasts and photographers. Travelers renting a Fortuner can drive through scenic hilly roads, stop at viewpoints to capture panoramic landscapes, and enjoy peaceful moments amid nature. The SUV’s high ground clearance ensures a comfortable ride on undulating terrain."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic reservoir on the outskirts of Pune, perfect for peaceful outings and photography. Travelers with a Fortuner rental can enjoy a relaxing drive to the dam, take leisurely walks by the water, capture sunset views, and have picnics with family or friends. The SUV’s spacious interior and powerful performance make it ideal for group travel and longer journeys."
  }
],



services: [
{
name: "Fortuner on Rent Pune",
description: "Fortuner on rent in Pune offers a premium SUV travel experience for customers looking for luxury, comfort, and powerful performance. The Toyota Fortuner is ideal for corporate travel, weddings, VIP transport, and outstation journeys. With spacious interiors, high seating comfort, and strong road presence, it ensures a premium travel experience. Professional chauffeurs provide safe and smooth driving across city and highway routes. Air-conditioned cabins, leather seating, and ample luggage space make it perfect for long-distance travel. Easy booking options with transparent pricing make Fortuner rental a top choice for luxury travel in Pune."
},
{
name: "Fortuner Rent in Pune",
description: "Fortuner rent in Pune provides flexible rental options for daily, weekly, and monthly usage. Customers can book this premium SUV for personal travel, business meetings, and special occasions with professional driver support."
},
{
name: "Toyota Fortuner on Rent in Pune",
description: "Toyota Fortuner on rent in Pune offers reliable and luxurious travel with advanced features, comfortable seating, and powerful performance for city and outstation trips."
},
{
name: "Toyota Fortuner Rental in Pune",
description: "Toyota Fortuner rental in Pune ensures premium travel experience with well-maintained vehicles and professional drivers for safe and comfortable journeys."
},
{
name: "Toyota Fortuner Rental in Pune Airport",
description: "Toyota Fortuner rental at Pune airport provides convenient pickup and drop services for travelers looking for luxury transport directly from the airport."
},
{
name: "Toyota Fortuner Rental in Pune Airport Contact Number",
description: "Toyota Fortuner rental contact number in Pune airport helps customers quickly book premium SUV services for airport transfers and city travel."
},
{
name: "Toyota Fortuner Hire for Corporate Events",
description: "Toyota Fortuner hire for corporate events offers premium transportation for executives, meetings, and business travel with stylish and comfortable vehicles."
},
{
name: "Toyota Fortuner Hire for Corporate Events Near Me",
description: "Fortuner hire near you for corporate events provides convenient booking options with reliable service and luxury travel experience."
},
{
name: "Toyota Fortuner Hire for Wedding Function",
description: "Toyota Fortuner hire for wedding functions offers stylish and elegant transportation for special occasions with premium comfort and luxury appeal."
},
{
name: "Fortuner on Rent for Wedding",
description: "Fortuner on rent for wedding provides a grand and luxurious entry option with comfortable seating and premium interiors for special events."
},
{
name: "Fortuner Rent for One Day",
description: "Fortuner rent for one day offers flexible rental options for short trips, events, and business meetings with professional driver support."
},
{
name: "Fortuner Hire in Pimpri Chinchwad",
description: "Fortuner hire in Pimpri Chinchwad provides premium SUV travel for residents and corporate clients with comfortable and reliable service."
},
{
name: "Fortuner on Rent for Outstation",
description: "Fortuner on rent for outstation travel offers powerful performance and comfortable seating for long-distance journeys across Maharashtra and beyond."
},
{
name: "Fortuner Hire for Corporate Office",
description: "Fortuner hire for corporate office ensures professional and comfortable transportation for executives and employees."
},
{
name: "Fortuner on Rent in Pune Monthly",
description: "Fortuner on rent in Pune monthly offers long-term rental solutions for corporate clients and individuals requiring regular luxury travel."
},
{
name: "Fortuner Rent per Km",
description: "Fortuner rent per km provides transparent pricing based on distance and travel duration, helping customers plan their budget effectively."
},
{
name: "Fortuner on Rent in Mumbai",
description: "Fortuner on rent in Mumbai offers premium SUV travel for city rides, airport transfers, and outstation trips with professional drivers."
},
{
name: "Fortuner Car on Rent in Mumbai",
description: "Fortuner car on rent in Mumbai provides luxury travel options with comfortable seating and reliable service for business and personal travel."
},
{
name: "Fortuner Rent in Mumbai",
description: "Fortuner rent in Mumbai offers flexible rental options for daily and long-term use with premium travel experience."
},
{
name: "Toyota Fortuner on Rent in Velocity Cabs",
description: "Velocity Cabs provides premium Toyota Fortuner rental services with reliable vehicles, experienced drivers, and competitive pricing for luxury travel."
},
{
name: "Fortuner on Rent in Pune",
description: "Fortuner on rent in Pune offers dependable and luxurious transportation for all travel needs including corporate, weddings, and outstation trips."
},
{
name: "Toyota Fortuner Rental Pune",
description: "Toyota Fortuner rental Pune provides high-quality SUV travel with premium comfort, safety, and performance for all types of journeys."
}
],

tableData: [
["Fortuner on Rent Pune","Fortuner Rent in Pune"],
["Toyota Fortuner on Rent in Pune","Toyota Fortuner Rental in Pune"],
["Toyota Fortuner Rental in Pune Airport","Toyota Fortuner Rental in Pune Airport Contact Number"],
["Toyota Fortuner Hire for Corporate Events","Toyota Fortuner Hire for Corporate Events Near Me"],
["Toyota Fortuner Hire for Wedding Function","Fortuner on Rent for Wedding"],
["Fortuner Rent for One Day","Fortuner Hire in Pimpri Chinchwad"],
["Fortuner on Rent for Outstation","Fortuner Hire for Corporate Office"],
["Fortuner on Rent in Pune Monthly","Fortuner Rent per Km"],
["Fortuner on Rent in Mumbai","Fortuner Car on Rent in Mumbai"],
["Fortuner Rent in Mumbai","Toyota Fortuner on Rent in Velocity Cabs"],
["Fortuner on Rent in Pune","Toyota Fortuner Rental Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Luxury Fortuner Experience",
    WhyChoosedescription: "Velocity Cabs offers Toyota Fortuner on rent in Pune with premium interiors, powerful performance, and high ground clearance, making it perfect for luxury travel, corporate trips, and VIP movements."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Pune city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Fortuner rental in Pune. Customers receive complete fare details including per km charges, toll charges, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Fortuner rental service in Pune operates 24/7. Whether for airport transfer, business travel, or outstation trips, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC SUV",
    WhyChoosedescription: "All Fortuner vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe, comfortable, and premium travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible rental options including local city use (8 hours/80 km), outstation trips, one-way travel, round-trip bookings, and customized packages."
  },
  {
    WhyChooseheading: "Ideal for VIP & Corporate Travel",
    WhyChoosedescription: "Fortuner is ideal for VIP guests, corporate executives, weddings, and premium travel with seating for 6 to 7 passengers and spacious interiors."
  },
  {
    WhyChooseheading: "Trusted SUV Rental Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Fortuner on rent in Pune due to professional drivers, luxury vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Fortuner on rent in Pune?", answer: "Yes, Velocity Cabs provides Toyota Fortuner rental services in Pune for local and outstation travel." },
  { question: "What is the price of Fortuner on rent in Pune?", answer: "Fortuner rental typically starts from ₹25 to ₹35 per km or ₹4000 to ₹7000 per day depending on the package and duration." },
  { question: "How many passengers can travel in Fortuner?", answer: "Fortuner can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Is Fortuner available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using Fortuner vehicles." },
  { question: "Can I book Fortuner for outstation trips?", answer: "Yes, Fortuner is available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Fortuner rental service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Fortuner vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Fortuner online?", answer: "Yes, customers can easily book Fortuner on rent in Pune online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for a safe and comfortable journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback:
      "The Fortuner rental in Pune was perfect for our weekend travel. The SUV was in excellent condition, offered great comfort, and made the journey feel premium throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback:
      "A Fortuner was arranged for our Pune trip and the experience was very smooth. The ride quality was excellent, the vehicle was spotless, and the overall service felt very professional.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const fortunerJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Fortuner On Rent in Pune | Velocity Cabs",
  "description": "Rent a Toyota Fortuner in Pune for airport transfers, outstation trips, corporate events, weddings, and one-day rentals. Available in Pimpri-Chinchwad, Pune airport, and citywide for premium taxi service.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Fortuner On Rent Pune",
    "Toyota Fortuner Rental Pune",
    "Fortuner Airport Transfer Pune",
    "Fortuner Outstation Hire Pune",
    "Fortuner Corporate Events Hire Pune",
    "Fortuner Wedding Function Hire Pune",
    "Fortuner One Day Rental Pune",
    "Fortuner Hire Pimpri Chinchwad"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Fortuner On Rent in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a Toyota Fortuner in Pune for airport transfers, outstation trips, corporate events, weddings, and one-day rentals. Available in Pimpri-Chinchwad, Pune airport, and citywide for premium taxi service."
  />
  <script type="application/ld+json">
    {JSON.stringify(fortunerJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fortuneronrentinpune;